import { Loader } from "@googlemaps/js-api-loader";

export const mapsLoader = new Loader({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY!,   // .env injects this
  version: "weekly",
  libraries: ["places"],                                // add/remove as needed
});

